export const buildProgressArcPath = (
  progress: number,
  radius = 45,
  counterClockwise = false
): string => {
  const clamped = Math.min(
    1,
    Math.max(0, Number.isFinite(progress) ? progress : 0)
  );
  if (clamped <= 0) return '';
  const startAngle = -Math.PI / 2;
  if (clamped >= 0.9999) {
    const midAngle = counterClockwise
      ? startAngle - Math.PI
      : startAngle + Math.PI;
    const midX = 50 + radius * Math.cos(midAngle);
    const midY = 50 + radius * Math.sin(midAngle);
    const startX = 50;
    const startY = 50 - radius;
    const sweep = counterClockwise ? 0 : 1;
    return `M ${startX} ${startY} A ${radius} ${radius} 0 1 ${sweep} ${midX} ${midY} A ${radius} ${radius} 0 1 ${sweep} ${startX} ${startY}`;
  }

  const angle = counterClockwise
    ? startAngle - clamped * Math.PI * 2
    : startAngle + clamped * Math.PI * 2;
  const endX = 50 + radius * Math.cos(angle);
  const endY = 50 + radius * Math.sin(angle);
  const largeArcFlag = clamped > 0.5 ? 1 : 0;
  const sweepFlag = counterClockwise ? 0 : 1;
  return `M 50 ${50 - radius} A ${radius} ${radius} 0 ${largeArcFlag} ${sweepFlag} ${endX} ${endY}`;
};

export default buildProgressArcPath;
